
import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";
import { Banner, Content } from "./models";



const onboardApi = createApi({
    reducerPath: "onboardApi",
    baseQuery: fetchBaseQueryCSRF({ baseUrl: `${CROSS_API_URL}/onboard` }),
    endpoints: (builder) => ({
        dismissOnboardBanner: builder.mutation<void, number>({
            query: (id) => ({
                url: `/user/banners/${id}/close`,
                method: "POST",
            }),
        }),
        getOnboard: builder.query<Banner[], void>({
            query: () => ({
                url: "/user/banners",
                method: "GET",
            }),
        }),
        getBanners: builder.query<Banner[], void>({
            query: () => ({
                url: "/banners",
                method: "GET",
            }),
        }),
        createBanner: builder.mutation<{id: number}, Omit<Banner, "id">>({
            query: (banner) => ({
                url: "/banners",
                method: "POST",
                body: banner,
            }),
        }),
        putBannerTranslations: builder.mutation<void, { id: number, translation: Content }>({
            query: ({ id, translation }) => ({
                url: `/banners/${id}/translations`,
                method: "PUT",
                body: translation,
            }),
        }),
        updateBanner: builder.mutation<void, Banner>({
            query: ({id, ...banner}) => ({
                url: `/banners/${id}`,
                method: "PATCH",
                body: banner,
            }),
        }),
        deleteBanner: builder.mutation<void, number>({
            query: (id) => ({
                url: `/banners/${id}`,
                method: "DELETE",
            }),
        }),
        getBanner: builder.query<Banner, number>({
            query: (id) => ({
                url: `/banners/${id}`,
                method: "GET",
            }),
        }),
    }),
});

export const { 
    useGetBannersQuery, 
    useCreateBannerMutation, 
    useUpdateBannerMutation, 
    useDeleteBannerMutation, 
    useGetBannerQuery,
    useGetOnboardQuery,
    useDismissOnboardBannerMutation,
    usePutBannerTranslationsMutation
} = onboardApi;

export default onboardApi;